import { mockApiRegistry } from "@lst/ui-components-vue";

/**
 * Register all mock API handlers for the Operations app
 *
 * This function imports and registers mock handlers from all modules.
 * Add new module handlers here as they are created.
 *
 * @param shouldEnableMock - Whether to enable mock API based on global flag or selective API configs
 */
export async function registerAllMockHandlers(shouldEnableMock: boolean): Promise<void> {
  if (!shouldEnableMock) {
    return;
  }

  mockApiRegistry.enable();

  // Import and register module-specific handlers
  const { registerAssetUnitHandlers } = await import(
    "@/pai-asset-registry/api/useAssetUnits/mocks"
  );
  registerAssetUnitHandlers();

  const { registerAllowedLocationHandlers } = await import(
    "@/pai-asset-registry/api/useAllowedLocations/mocks"
  );
  registerAllowedLocationHandlers();

  const { registerVendorHandlers } = await import(
    "@/pai-asset-registry/api/useVendors/mocks"
  );
  registerVendorHandlers();

  const { registerAssetGroupHandlers } = await import(
    "@/pai-asset-registry/api/useAssetGroups/mocks"
  );
  registerAssetGroupHandlers();

  const { registerAssetCategoryHandlers } = await import(
    "@/pai-asset-registry/api/useAssetCategories/mocks"
  );
  registerAssetCategoryHandlers();

  const { registerAssetModelHandlers } = await import(
    "@/pai-asset-registry/api/useAssetModels/mocks"
  );
  registerAssetModelHandlers();

  const { registerAssetModelVersionHandlers } = await import(
    "@/pai-asset-registry/api/useAssetModelVersions/mocks"
  );
  registerAssetModelVersionHandlers();

  const { registerAcquisitionHandlers } = await import(
    "@/pai-asset-registry/api/useAssetAquisitions/mocks"
  );
  registerAcquisitionHandlers();

  const { registerAssetHistoryHandlers } = await import(
    "@/pai-asset-registry/api/useAssetHistory/mocks"
  );
  registerAssetHistoryHandlers();

  const { registerAssetTagHandlers } = await import(
    "@/pai-asset-registry/api/useAssetTags/mocks"
  );
  registerAssetTagHandlers();

  console.log(
    `✅ Registered ${mockApiRegistry.getHandlerCount()} mock API handlers`
  );
}
